import { render } from "./Reference.vue?vue&type=template&id=ee95a64c&scoped=true"
import script from "./Reference.vue?vue&type=script&lang=js"
export * from "./Reference.vue?vue&type=script&lang=js"

import "./Reference.vue?vue&type=style&index=0&id=ee95a64c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee95a64c"]])

export default __exports__